import { render, staticRenderFns } from "./VipEdit.vue?vue&type=template&id=77135e1c&"
import script from "./VipEdit.vue?vue&type=script&lang=js&"
export * from "./VipEdit.vue?vue&type=script&lang=js&"
import style0 from "./VipEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports